export default "__VITE_ASSET__D61bP8Rj__"